<div>


  <div class="txt-ola">Olá,</div>
  <div class="txt-nome">{{this.modelLocator.dadosLogin.nome ? this.modelLocator.dadosLogin.nome.split(' ')[0] : ''}}!
  </div>
<!--
  <ion-row class="area-badge" *ngIf="modelLocator.menu.classificacao">
    <ion-col>
      <img src="../assets/badges/{{this.modelLocator.dadosLogin.classificacao}}.png"
        alt="{{this.modelLocator.dadosLogin.classificacao}}">
    </ion-col>
  </ion-row> -->

  <div class="box-pontos" *ngIf="modelLocator.menu.pontuacao">
    <span class="tit">PONTOS</span>
    <span class="pontos_usuario pt">{{modelLocator.saldo.tcoins_saldo ? modelLocator.saldo.tcoins_saldo : 0}}</span>
    <span class="tit-expirar" *ngIf="modelLocator.pts_expirar !== 0">A EXPIRAR:</span>
    <span class="pontos_usuario pt" *ngIf="modelLocator.pts_expirar !== 0">{{modelLocator.pts_expirar}}</span>
  </div>

  <!-- <ion-row class="ion-justify-content-center" *ngIf="modelLocator.menu.pontuacao">
    <div class="box-tickets desktop">
      <span class="pontos_usuario pt">{{modelLocator.saldo.ticket_saldo ? modelLocator.saldo.ticket_saldo : 0}}</span>
      <img src="../assets/image/ticket_menu.png" alt="">
    </div>
  </ion-row> -->

  <div class="traco-perfil"></div>

  <ion-col class="links-menu ion-align-self-center ion-text-center" style="display: contents;">
    <div *ngFor="let item of menuLeftColum">
      <!-- Aplique o *ngIf para ocultar o item se 'item.hidden' for true -->
      <ion-item [button]="true" lines="none" [disabled]="item.disabled" *ngIf="!item.hidden && modelLocator.menu[item.key]">
        <a (click)="touchGoToRoute(item.route)">{{item.label}}</a>
      </ion-item>
    </div>
  </ion-col>

  <!-- <div class="menu-perfil">

    <a (click)="touchGoToRoute('/profile')">Meu Perfil<br /></a>

    <a *ngIf="modelLocator.menu.pre" (click)="touchGoToRoute('/activation-pre')">Pré Pago<br /></a>

    <a *ngIf="modelLocator.menu.ativacoes" (click)="touchGoToRoute('/activation-list')">Minhas
      Ativações<br /></a>

    <a *ngIf="modelLocator.menu.qualidade" (click)="touchGoToRoute('/quality')">Minha Qualidade<br /></a>

    <a *ngIf="modelLocator.menu.carteira" (click)="touchGoToRoute('/wallet')">Minha Equipe<br /></a>

    <a *ngIf="modelLocator.menu.extrato" (click)="touchGoToRoute('/extract')">Meu Extrato<br /></a>

    <a *ngIf="modelLocator.menu.resgates" (click)="touchGoToRoute('/my-rescue')">Meus Resgates<br /></a>

    <a *ngIf="modelLocator.menu.uploads" (click)="touchGoToRoute('/uploads')">Meus Uploads<br /></a>

  </div> -->

  <div class="traco-perfil"></div>

  <div class="box-central-ajuda" (click)="touchGoToRoute('/help')">
    <a>
      <img src="../../../assets/icon/icone_central_ajuda.svg" alt="Central de Ajuda">
    </a>
    <div>
      <a><span class="txt-cinza-escuro-12">CENTRAL</span></a><br />
      <a><span class="txt-cinza-escuro-12">DE AJUDA</span></a>
    </div>
  </div>

  <!-- <div class="box-central-ajuda" (click)="touchGoToRoute('/faq')">
    <ion-col>
      <img src="../../../assets/icon/faq.svg" alt="Central de Ajuda">
    </ion-col>
    <ion-col>
      <a><span class="txt-cinza-escuro-12">FAC</span></a>
    </ion-col>
  </div> -->

</div>
